export const formatPrice = (n) => `Rs. ${Number(n).toLocaleString('en-PK')}`;
